import styled from "styled-components";


export const FAQWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin: 3rem auto;

    .item-1 .question {
        background: ${({ theme }) => theme === 'dark' ? 'rgb(52, 121, 126)' : 'rgb(100, 167, 170)'};
    }

    .item-2 .question {
        background: ${({ theme }) => theme === 'dark' ? 'rgb(46, 104, 110)' : 'rgb(130, 182, 184)'};
    }

    .item-3 .question {
        background: ${({ theme }) => theme === 'dark' ? 'rgb(38, 87, 93)' : 'rgb(158, 199, 200)'};
    }

    .item-4 .question {
        background: ${({ theme }) => theme === 'dark' ? 'rgb(29, 70, 76)' : 'rgb(188, 216, 218)'};
    }

    .item-5 .question {
        background: ${({ theme }) => theme === 'dark' ? 'rgb(21, 52, 61)' : 'rgb(216, 234, 233)'};
    }
`;

export const BoxStyled = styled.div`
    
    .question {
        display: flex;
        justify-content: space-between;
        border: none;
        color: ${({ theme }) => theme === 'dark' ? 'white' : 'black'};
        width: 90%;
        margin: 0 auto;
        border-radius: 0.625rem;
        text-align: left;
        padding: 1rem;
        font-size: 0.8rem;
        cursor: pointer;
        p{
            font-weight: 700;
        }
    }
    
    .answer{
        width: 85%;
        margin: 0 auto;
        background: rgba(111, 203, 209, 0.5);
        border-top: .7px solid #5fbec5;
        font-size: 0.8rem;
        padding: 1rem;
    }
`;